
// import React from "react";
// import FullCalendar from "@fullcalendar/react";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import "../styles/OneonOneAnalytics.css";

// const OneOnOneAnalyticsCard = React.memo(({ userData, handleModuleChange }) => {


//     const [groupedData, setGroupedData] = React.useState({});
//     const [selectedDate, setSelectedDate] = React.useState(null);
//     const [popupData, setPopupData] = React.useState([]);

//     // ✅ Fetch Data
//     React.useEffect(() => {
//         fetch(`/gt-api/get_oneonone.php?manager_id=${userData.id}&role=manager`)
//             .then(res => res.json())
//             .then(data => {
//                 const meetings = data.meetings || [];

//                 const grouped = {};

//                 meetings.forEach(meet => {
//                     const date = meet.meet_date;

//                     if (!grouped[date]) grouped[date] = [];

//                     grouped[date].push({
//                         name: meet.employee_name.split(" ")[0],
//                         status: meet.status
//                     });
//                 });

//                 setGroupedData(grouped);
//             });
//     }, []);

//     const allMeetings = Object.values(groupedData).flat();

//     const totalMeetings = allMeetings.length;

//     const completedMeetings = allMeetings.filter(
//         m => m.status !== "MISSED"
//     ).length;

//     const attendancePercent = totalMeetings
//         ? Math.round((completedMeetings / totalMeetings) * 100)
//         : 0;

//     return (
//         <div className="mgt-okr-card oneonone-card">

//             {/* HEADER */}
//             <div className="card-header header-with-action">
//                 <h3>1-on-1 Analytics</h3>

//                 <span
//                     className="header-link"
//                     onClick={() => handleModuleChange("manager-one-on-one")}
//                 >
//                     Go to One-on-One →
//                 </span>
//             </div>

//             {/* 📊 ATTENDANCE BAR */}
//             <div className="attendance-container">

//                 <div className="attendance-top">
//                     <span className="attendance-label">Attendance</span>
//                     <span className="attendance-value">
//                         {completedMeetings}/{totalMeetings} ({attendancePercent}%)
//                     </span>
//                 </div>

//                 <div className="attendance-bar">
//                     <div
//                         className="attendance-fill"
//                         style={{
//                             width: `${attendancePercent}%`,
//                             background:
//                                 attendancePercent >= 80
//                                     ? "#16a34a"   // green
//                                     : attendancePercent >= 50
//                                         ? "#f59e0b"   // yellow
//                                         : "#dc2626"   // red
//                         }}
//                     />
//                 </div>

//             </div>

//             {/* CALENDAR */}
//             <FullCalendar
//                 plugins={[dayGridPlugin]}
//                 initialView="dayGridMonth"

//                 height={360}



//                 expandRows={true}

//                 // headerToolbar={{
//                 //     left: "title",
//                 //     right: "today prev,next"
//                 // }}

//                 // buttonText={{
//                 //     today: "today"
//                 // }}

//                 headerToolbar={{
//                     left: "title",
//                     right: "prev,next"
//                 }}

//                 events={[]}

//                 dayCellContent={(arg) => {
//                     const dateStr = arg.date.toLocaleDateString("en-CA");
//                     const dayData = groupedData[dateStr] || [];

//                     const presentCount = dayData.filter(d => d.status !== "MISSED").length;
//                     const missedCount = dayData.filter(d => d.status === "MISSED").length;

//                     return (
//                         <div
//                             className="day-cell"
//                             onClick={() => {
//                                 setSelectedDate(dateStr);
//                                 setPopupData(dayData);
//                             }}
//                         >
//                             <div className="day-number">
//                                 {arg.dayNumberText}
//                             </div>


//                             <div className="dot-container">


//                                 {presentCount > 0 && (
//                                     <span className="dot green" />
//                                 )}


//                                 {missedCount > 0 && (
//                                     <span className="dot red" />
//                                 )}

//                             </div>
//                         </div>
//                     );
//                 }}
//             />


//             {/* POPUP */}
//             {selectedDate && (
//                 <div
//                     className="popup-overlay"
//                     onClick={() => setSelectedDate(null)}
//                 >
//                     <div
//                         className="popup-card"
//                         onClick={(e) => e.stopPropagation()}
//                     >
//                         <h3 className="popup-title">📅 {selectedDate}</h3>

//                         {popupData.length === 0 ? (
//                             <p className="empty-text">No meetings on this day</p>
//                         ) : (
//                             popupData.map((item, i) => (
//                                 <div key={i} className="popup-row">
//                                     <span>{item.name}</span>
//                                     <span className={item.status === "MISSED" ? "missed" : "present"}>
//                                         {item.status === "MISSED" ? "❌ Missed" : "✅ Present"}
//                                     </span>
//                                 </div>
//                             ))
//                         )}
//                     </div>
//                 </div>
//             )}

//         </div>
//     );
// });

// export default OneOnOneAnalyticsCard;





















import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import "../styles/OneonOneAnalytics.css";

const OneOnOneAnalyticsCard = React.memo(({ userData, handleModuleChange }) => {


    const [groupedData, setGroupedData] = React.useState({});
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [popupData, setPopupData] = React.useState([]);

    // ✅ Fetch Data
    React.useEffect(() => {
        fetch(`/gt-api/get_oneonone.php?manager_id=${userData.id}&role=manager`)
            .then(res => res.json())
            .then(data => {
                const meetings = data.meetings || [];

                const grouped = {};

                meetings.forEach(meet => {
                    const date = meet.meet_date;

                    if (!grouped[date]) grouped[date] = [];

                    grouped[date].push({
                        name: meet.employee_name.split(" ")[0],
                        status: meet.status
                    });
                });

                setGroupedData(grouped);
            });
    }, []);

    const allMeetings = Object.values(groupedData).flat();

    const totalMeetings = allMeetings.length;

    const completedMeetings = allMeetings.filter(
        m => m.status !== "MISSED"
    ).length;

    const attendancePercent = totalMeetings
        ? Math.round((completedMeetings / totalMeetings) * 100)
        : 0;

    return (
        <div className="mgt-okr-card oneonone-card">

            {/* HEADER */}
            <div className="card-header header-with-action">
                {/* <h3>1-on-1 Analytics</h3> */}
                <button
                    className="header-report-btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleModuleChange("one-on-one-report");
                    }}
                >
                    📊 Generate Report
                </button>

                <div className="header-actions-group">
                    <span
                        className="header-link"
                        onClick={() => handleModuleChange("manager-one-on-one")}
                    >
                        Go to One-on-One →
                    </span>
                </div>
            </div>

            {/* 📊 ATTENDANCE BAR */}
            <div className="attendance-container">

                <div className="attendance-top">
                    <span className="attendance-label">Attendance</span>
                    <span className="attendance-value">
                        {completedMeetings}/{totalMeetings} ({attendancePercent}%)
                    </span>
                </div>

                <div className="attendance-bar">
                    <div
                        className="attendance-fill"
                        style={{
                            width: `${attendancePercent}%`,
                            background:
                                attendancePercent >= 80
                                    ? "#16a34a"   // green
                                    : attendancePercent >= 50
                                        ? "#f59e0b"   // yellow
                                        : "#dc2626"   // red
                        }}
                    />
                </div>

            </div>

            {/* CALENDAR */}
            <FullCalendar
                plugins={[dayGridPlugin]}
                initialView="dayGridMonth"

                height={360}



                expandRows={true}

                // headerToolbar={{
                //     left: "title",
                //     right: "today prev,next"
                // }}

                // buttonText={{
                //     today: "today"
                // }}

                headerToolbar={{
                    left: "title",
                    right: "prev,next"
                }}

                events={[]}

                dayCellContent={(arg) => {
                    const dateStr = arg.date.toLocaleDateString("en-CA");
                    const dayData = groupedData[dateStr] || [];

                    const presentCount = dayData.filter(d => d.status !== "MISSED").length;
                    const missedCount = dayData.filter(d => d.status === "MISSED").length;

                    return (
                        <div
                            className="day-cell"
                            onClick={() => {
                                setSelectedDate(dateStr);
                                setPopupData(dayData);
                            }}
                        >
                            <div className="day-number">
                                {arg.dayNumberText}
                            </div>


                            <div className="dot-container">


                                {presentCount > 0 && (
                                    <span className="dot green" />
                                )}


                                {missedCount > 0 && (
                                    <span className="dot red" />
                                )}

                            </div>
                        </div>
                    );
                }}
            />


            {/* POPUP */}
            {selectedDate && (
                <div
                    className="popup-overlay"
                    onClick={() => setSelectedDate(null)}
                >
                    <div
                        className="popup-card"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h3 className="popup-title">📅 {selectedDate}</h3>

                        {popupData.length === 0 ? (
                            <p className="empty-text">No meetings on this day</p>
                        ) : (
                            popupData.map((item, i) => (
                                <div key={i} className="popup-row">
                                    <span>{item.name}</span>
                                    <span className={item.status === "MISSED" ? "missed" : "present"}>
                                        {item.status === "MISSED" ? "❌ Missed" : "✅ Present"}
                                    </span>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}

        </div>
    );
});

export default OneOnOneAnalyticsCard;